"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _configuratorCarousel = require("@mmc/configurator-carousel");
var _configuratorPackageSelector = require("@mmc/configurator-package-selector");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _actions = require("../actions");
var _disclaimer = _interopRequireDefault(require("./disclaimer/disclaimer"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  handleNestedProp = dataUtils.handleNestedProp;
var PackagesSelector = /*#__PURE__*/function (_React$Component) {
  function PackagesSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.changeEvent = _this.changeEvent.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(PackagesSelector, _React$Component);
  var _proto = PackagesSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var dispatch = this.props.dispatch;
    var validPackages = this.getValidPackages();
    dispatch((0, _actions.setPackages)(validPackages));
  };
  _proto.getValidPackages = function getValidPackages() {
    var _this2 = this;
    var _this$props = this.props,
      data = _this$props.data,
      dispatch = _this$props.dispatch,
      _this$props$packages = _this$props.packages,
      packages = _this$props$packages === void 0 ? [] : _this$props$packages,
      preferences = _this$props.preferences;
    var preferredPackages = preferences.packages || [];
    var allPackages = handleNestedProp(data, 'data.filter.filteringOptions');
    var validPackages = [];
    var selectedPackages = packages.concat(preferredPackages);
    var forcedOptionCodes = data.forcedOptionCodes;
    if (allPackages !== ' ') {
      allPackages.forEach(function (currentPackage) {
        if (selectedPackages.includes(currentPackage.code) || forcedOptionCodes.includes(currentPackage.code)) {
          validPackages.push(currentPackage.code);

          // When the forced selected package has notCompatibleOptions, this adds those codes as default greyed-out packages. Users cannot select those packages.
          if (currentPackage.notCompatibleOptions) {
            var incompatibleCodes = _this2.props.incompatibleCodes;
            var nextState = [].concat(incompatibleCodes, currentPackage.notCompatibleOptions);
            dispatch((0, _actions.setIncompatibleCodes)(nextState));
          }
        }
      });
    }
    return validPackages;
  };
  _proto.changeEvent = function changeEvent(e) {
    var _this$props2 = this.props,
      data = _this$props2.data,
      dispatch = _this$props2.dispatch,
      packages = _this$props2.packages;
    var updatedPackages = packages.slice();
    var selectedPackage = e.target.value;
    var selectedPackageIndex = packages.indexOf(selectedPackage);
    var selectedPackageObj = data.filter.filteringOptions.find(function (p) {
      return p.code === selectedPackage;
    });
    var options = selectedPackageObj.notCompatibleOptions ? selectedPackageObj.notCompatibleOptions : [];
    // Toggle the package in our array
    if (selectedPackageIndex === -1) {
      updatedPackages.push(selectedPackage);
      if (selectedPackageObj) {
        var incompatibleCodes = this.props.incompatibleCodes;
        var nextState = [].concat(incompatibleCodes, options);
        dispatch((0, _actions.setIncompatibleCodes)(nextState));

        // This is needed when if there is already checked packages, but when it has to be unselected due to compatibility
        updatedPackages = updatedPackages.filter(function (code1) {
          return !options.some(function (code2) {
            return code1 === code2;
          });
        });
      }
    } else {
      updatedPackages.splice(selectedPackageIndex, 1);
      if (selectedPackageObj) {
        var _incompatibleCodes = this.props.incompatibleCodes;
        var _nextState = _incompatibleCodes.filter(function (code1) {
          return !options.some(function (code2) {
            return code1 === code2;
          });
        });
        dispatch((0, _actions.setIncompatibleCodes)(_nextState));
      }
    }

    // Update Redux
    dispatch((0, _actions.setPackages)(updatedPackages));
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      packages = _this$props3.packages,
      incompatibleCodes = _this$props3.incompatibleCodes,
      minorQueryPending = _this$props3.minorQueryPending,
      market = _this$props3.market,
      data = _this$props3.data,
      _this$props3$theme = _this$props3.theme,
      theme = _this$props3$theme === void 0 ? {} : _this$props3$theme;
    var filter = data.filter,
      headingText = data.headingText,
      forcedOptionCodes = data.forcedOptionCodes;
    var carousel = data.carousel || {};
    var PackagesSelectorData = {
      filter: filter,
      headingText: headingText,
      forcedOptionCodes: forcedOptionCodes
    };
    var direction = this.props.direction;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].stepContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configurator["default"].loaderWrapper
    }, !isEmptyArray(carousel.items) && /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
      theme: theme,
      data: carousel,
      isLoading: minorQueryPending > 0
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme.marginBottom40,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement(_configuratorPackageSelector.ConfiguratorPackageSelector, {
      theme: theme,
      data: PackagesSelectorData,
      changeEvent: this.changeEvent,
      selectedPackages: packages,
      notCompatibleOptionCodes: incompatibleCodes
    }), data.disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer
    }, data.disclaimer))), data.disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-md-offset-1'] + " " + theme['col-md-10']
    }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
      theme: theme,
      headline: "Disclaimer",
      content: data.disclaimer
    }))));
  };
  return PackagesSelector;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    packages: state.packages.value,
    incompatibleCodes: state.incompatibleCodes.value,
    minorQueryPending: props.minorQueryPending,
    preferences: props.preferences,
    theme: props.theme,
    data: props.data
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(PackagesSelector);